export const BASE_URL = 'https://api-v1.serverpoint.com';
export const siteKey = '6Ld7n7YfAAAAAHJ-8cozc94qgmtfSseInlUT5Ty3';
